import React, { MouseEvent } from 'react'
import styles from './style.module.scss'
import cls from 'classnames'
import groovyWalkAnimation from './live-entrance.json'
import dynamic from 'next/dynamic'
import { HCNextLink } from '@/components/HCNextLink'

const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

type MenuItemProps = {
  title: string
  description: string
  leftIcon: React.ReactNode
  // callBack?: (event: MouseEvent<HTMLDivElement>, props: MenuItemProps) => void
  _key: string
  link: string
  suffix: string
}

const MenuItem = (props: MenuItemProps) => {
  return (
    <HCNextLink className={styles.container} href={props.link} style={{ padding: '16px', paddingRight: '20px' }}>
      <div className={cls([styles.leftIcon, styles[props._key]])}></div>
      <div className={styles.content}>
        <div className={styles.title}>
          {props.title}
          {props?.suffix && <div className={styles[props?.suffix]}></div>}
          {props._key === 'live' && props.liveIngData && props.liveIngData.length > 0 && (
            <Lottie
              style={{
                width: '12px',
                height: '12px',
                marginLeft: '5px',
              }}
              animationData={groovyWalkAnimation}
              loop={true}
            />
          )}
        </div>
        <div className={styles.description}>{props.description}</div>
      </div>
    </HCNextLink>
  )
}
export default MenuItem
